import { render, staticRenderFns } from "./BotSubscription.vue?vue&type=template&id=6f6e63d8&scoped=true"
import script from "./BotSubscription.vue?vue&type=script&lang=js"
export * from "./BotSubscription.vue?vue&type=script&lang=js"
import style0 from "./BotSubscription.vue?vue&type=style&index=0&id=6f6e63d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6e63d8",
  null
  
)

export default component.exports